import { render, staticRenderFns } from "./CrearAlarma.vue?vue&type=template&id=35de2e7b&"
import script from "./CrearAlarma.vue?vue&type=script&lang=ts&"
export * from "./CrearAlarma.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports